import { ParentEvent } from '@g.frame/core';
import { CircleGeometry, Mesh, MeshBasicMaterial, Vector2 } from 'three';
import { FONT, TEXTURE } from '@g.frame/common.loaders';
import { ActionControllerEventName } from '@g.frame/common.action_controller';
import BackgroundElement from './uiElements/BackgroundElement';
import BodyTextElement from './uiElements/BodyTextElement';
import HeaderTextElement from './uiElements/HeaderTextElement';
import TextButtonElement from './uiElements/TextButtonElement';
import ModularPopUp from './ModularPopUp';
const styleConfig = {
    success: {
        icon: {
            radius: 1,
            segments: 16,
            texture: 'TEXTURE_success_popup_icon',
            margin: 0
        },
        header: {
            text: 'Good job!',
            window: {
                size: new Vector2(.510, .028),
                scale: 1,
                pxScale: 1
            },
            margin: .04 + .0185,
        },
        body: {
            text: 'Your answer is correct!',
            window: {
                offSet: 0,
                size: new Vector2(),
                scale: 1,
                pxScale: 1
            }
        },
        button: {
            text: 'Continue',
            margin: .278 + .0255,
            window: {
                size: new Vector2(.498, .051),
                scale: 1,
                pxScale: 1
            }
        }
    },
    fail: {
        icon: {
            radius: .028,
            segments: 32,
            texture: 'TEXTURE_fail_popup_icon',
            margin: .04 + .014
        },
        header: {
            text: 'Incorrect',
            window: {
                size: new Vector2(.140, .037),
                scale: 1,
                pxScale: 1
            },
            margin: .112 + .0185,
        },
        body: {
            text: 'Your answer is incorrect. Go back and think carefully about your answer. ',
            window: {
                size: new Vector2(.498, .052),
                scale: 1,
                pxScale: 1.75
            },
            margin: .165 + .026,
        },
        button: {
            text: 'Try Again',
            margin: .278 + .0255,
            window: {
                size: new Vector2(.498, .051),
                scale: 1,
                pxScale: 1
            }
        }
    },
    final: {
        icon: {
            radius: .028,
            segments: 32,
            texture: 'TEXTURE_final_popup_icon',
            margin: .04 + .014
        },
        header: {
            text: 'Level Finish',
            window: {
                size: new Vector2(.510, .028),
                scale: 1,
                pxScale: 1
            },
            margin: .10 + .0185,
        },
        body: {
            text: 'default body text is displayed here you better update it...',
            margin: .19 + .026,
            window: {
                size: new Vector2(.498, .104),
                scale: 1,
                pxScale: 3
            }
        },
        button: {
            text: 'Replay',
            margin: .278 + .0255,
            window: {
                size: new Vector2(.241, .051),
                scale: 1,
                pxScale: 1
            }
        },
        secondButton: {
            text: 'Back to lobby',
            margin: .278 + .0255,
            window: {
                size: new Vector2(.241, .051),
                scale: 1,
                pxScale: 1
            }
        }
    },
    welcome: {
        // iconTexture: 'TEXTURE_final_popup_icon',
        header: {
            text: 'default header',
            window: {
                size: new Vector2(.510, .028),
                scale: 1,
                pxScale: 1
            },
            margin: .04 + .0185,
        },
        body: {
            text: 'default body text is displayed here you better update it...',
            windowRows: {
                4: {
                    margin: .093 + .052,
                    window: {
                        size: new Vector2(.498, .104),
                        scale: 1,
                        pxScale: 3
                    }
                },
                3: {
                    margin: .093 + .052,
                    window: {
                        size: new Vector2(.498, .104),
                        scale: 1,
                        pxScale: 3
                    }
                }
            }
        },
        button: {
            text: 'Continue',
            margin: .278 + .0255,
            window: {
                size: new Vector2(.498, .051),
                scale: 1,
                pxScale: 1
            }
        }
    },
    background: {
        size: new Vector2(.562, .361)
    }
};
export default class PopUp extends ModularPopUp {
    constructor(loader, actionController, textComponentFactory) {
        super();
        this.loader = loader;
        this.actionController = actionController;
        this.textComponentFactory = textComponentFactory;
        this.loader.addResources([
            // {
            //     name: 'TASKTEXT_main_topright_corner',
            //     url: require('../../../assets/popups/text_main_topright_corner.png'),
            //     type: TEXTURE
            // },
            // {
            //     name: 'TASKTEXT_voice_button',
            //     url: require('../../../assets/popups/voice_button.png'),
            //     type: TEXTURE
            // },
            {
                name: 'TEXTURE_success_popup_icon',
                url: require('../assets/success_popup_icon.png'),
                type: TEXTURE
            },
            {
                name: 'TEXTURE_fail_popup_icon',
                url: require('../assets/fail_popup_icon.png'),
                type: TEXTURE
            },
            {
                name: 'TEXTURE_final_popup_icon',
                url: require('../assets/final_popup_icon.png'),
                type: TEXTURE
            },
            {
                name: 'OpenSans&otf-800-normal',
                url: require('../../../../assets/fonts/OpenSans-ExtraBold.otf'),
                type: FONT
            },
            {
                name: 'OpenSans&otf-700-normal',
                url: require('../../../../assets/fonts/OpenSans-Bold.otf'),
                type: FONT
            },
            {
                name: 'OpenSans&otf-500-normal',
                url: require('../../../../assets/fonts/OpenSans-Medium.otf'),
                type: FONT
            },
            {
                name: 'OpenSans&otf-400-normal',
                url: require('../../../../assets/fonts/OpenSans-Regular.otf'),
                type: FONT
            },
            {
                name: 'OpenSans&otf-300-normal',
                url: require('../../../../assets/fonts/OpenSans-Light.otf'),
                type: FONT
            },
            {
                name: 'RammettoOne&otf-400-normal',
                url: require('../../../../assets/fonts/RammettoOne-Regular.otf'),
                type: FONT
            },
        ]);
        this.actionController.on(ActionControllerEventName.click, this.uiObject, (event) => {
            if (event.data.intersection.orderNumber !== 0)
                return;
        });
        this.uiObject.name = 'TaskText';
        this.background = new BackgroundElement();
        this.headerText = new HeaderTextElement(this.loader, this.textComponentFactory);
        this.bodyText = new BodyTextElement(this.loader, this.textComponentFactory);
        this.button = new TextButtonElement(this.loader, this.actionController, this.textComponentFactory);
        this.secondButton = new TextButtonElement(this.loader, this.actionController, this.textComponentFactory);
    }
    resetPopUp() {
        this.secondButton.uiObject.position.setScalar(0);
        this.button.uiObject.position.setScalar(0);
        this.secondButton && this.disposeObject(this.secondButton);
        this.background && this.disposeObject(this.background);
        this.headerText && this.disposeObject(this.headerText);
        this.bodyText && this.disposeObject(this.bodyText);
        this.button && this.disposeObject(this.button);
        this.icon && this.disposeObject(this.icon);
        this.button && this.button.off('click');
        this.secondButton && this.secondButton.off('click');
        this.actionController.off(ActionControllerEventName.click, this.uiObject);
        this.elements = [];
        this.initBackground();
    }
    setPopUp(options) {
        this.popUpOptions = options;
        this.resetPopUp();
        if (options.type === 'welcome') {
            this.initWelcome();
        }
        else if (options.type === 'final') {
            this.initIcon();
            this.initFinal();
        }
        else {
            this.initText();
            this.initButton();
            this.initIcon();
            //
        }
        this.set({
            background: this.background,
            elements: this.elements
        });
    }
    initText() {
        const style = styleConfig[this.popUpOptions.type];
        this.headerText.set({
            text: style.header.text,
            window: style.header.window
        });
        this.elements.push({
            object: this.headerText,
            margin: style.header.margin
        });
        this.bodyText.set({
            text: style.body.text,
            invertedColors: true,
            window: style.body.window
        });
        this.elements.push({
            object: this.bodyText,
            margin: style.body.margin
        });
    }
    initButton() {
        const style = styleConfig[this.popUpOptions.type];
        this.button.set({
            text: style.button.text,
            window: style.button.window,
        });
        this.button.on('click', (event) => {
            this.fire('first_button_click', new ParentEvent('first_button_click'));
        });
        this.elements.push({
            object: this.button,
            margin: style.button.margin
        });
    }
    initIcon() {
        const style = styleConfig[this.popUpOptions.type];
        if (style.icon) {
            this.icon = new Mesh(new CircleGeometry(style.icon.radius, style.icon.segments), new MeshBasicMaterial({
                map: this.loader.getResource(style.icon.texture),
                transparent: true
            }));
            this.elements.push({
                object: this.icon,
                margin: style.icon.margin
            });
        }
    }
    initBackground() {
        this.background.set({
            size: styleConfig.background.size,
        });
    }
    initWelcome() {
        this.headerText.set({
            text: this.popUpOptions.header || styleConfig.welcome.header.text,
            window: styleConfig.welcome.header.window
        });
        this.elements.push({
            object: this.headerText,
            margin: styleConfig.welcome.header.margin
        });
        this.bodyText.set({
            text: this.popUpOptions.body || styleConfig.welcome.body.text,
            invertedColors: true,
            window: styleConfig.welcome.body.windowRows[this.popUpOptions.welcomeBodyRows].window
        });
        this.elements.push({
            object: this.bodyText,
            margin: styleConfig.welcome.body.windowRows[this.popUpOptions.welcomeBodyRows].margin
        });
        this.button.set({
            text: styleConfig.welcome.button.text,
            window: styleConfig.welcome.button.window,
        });
        this.button.on('click', (event) => {
            this.fire('first_button_click', new ParentEvent('first_button_click'));
        });
        this.elements.push({
            object: this.button,
            margin: styleConfig.welcome.button.margin
        });
    }
    initFinal() {
        this.headerText.set({
            text: this.popUpOptions.header || styleConfig.final.header.text,
            window: styleConfig.final.header.window
        });
        this.elements.push({
            object: this.headerText,
            margin: styleConfig.final.header.margin
        });
        this.bodyText.set({
            text: this.popUpOptions.body || styleConfig.final.body.text,
            invertedColors: true,
            window: styleConfig.final.body.window
        });
        this.elements.push({
            object: this.bodyText,
            margin: styleConfig.final.body.margin
        });
        this.button.set({
            text: styleConfig.final.button.text,
            window: styleConfig.final.button.window,
        });
        this.button.on('click', (event) => {
            this.fire('first_button_click', new ParentEvent('first_button_click'));
        });
        this.elements.push({
            object: this.button,
            margin: styleConfig.final.secondButton.margin
        });
        this.secondButton.set({
            text: this.popUpOptions.secondButton || styleConfig.final.secondButton.text,
            window: styleConfig.final.secondButton.window,
        });
        this.secondButton.on('click', (event) => {
            this.fire('second_button_click', new ParentEvent('first_button_click'));
        });
        this.elements.push({
            object: this.secondButton,
            margin: styleConfig.final.secondButton.margin
        });
        const buttonMargin = .008 + .241 / 2;
        this.button.uiObject.position.x -= buttonMargin;
        this.secondButton.uiObject.position.x += buttonMargin;
    }
}
